import './article.css';
import { NavLink, useParams } from "react-router-dom";
import LOGO from '../../assets/images/logo-small.jpg';
import { article1 } from "./data/one";
import { article2 } from "./data/two";
import { article3 } from "./data/three";
import { article4 } from "./data/four";
import { article5 } from "./data/five";

const Article = () => {
    let { id } = useParams();
    id = Number(id)
    return (
        <div>
            <div className='navbar'>
                <div className='logo-box'>
                    <NavLink to='/'>
                        <img src={LOGO} alt="claps_media_logo" className='navbar-logo'></img>
                    </NavLink>
                    {/* <p className='logo-text'>Fashion Lawyer India</p> */}
                </div>
                <div className='navbar-items'>
                    <span className='navbar-link'><a href='#intro'>About Us</a></span>
                    <span className='navbar-link'><a href='#services'>Services</a></span>
                    <span className='navbar-link'><a href='#team'>Team</a></span>
                    <span className='navbar-link'><a href='#gallery'>Articles</a></span>
                    <span className='navbar-link'><a href='#contact'>Contact Us</a></span>
                </div>
            </div>
            <div className="articles">
                {
                    id === 1 ? article1 :
                        id === 2 ? article2 :
                            id === 3 ? article3 :
                                id === 4 ? article4 :
                                    id === 5 ? article5 : article1
                }
            </div>
        </div>
    )
}

export default Article;